import { jsxs as l, jsx as e } from "react/jsx-runtime";
import w, { useState as N } from "react";
import { isNil as r } from "es-toolkit/compat";
import h from "./MobileHeaderModal.js";
const C = (d) => {
  const { appMenuItems: i, appNavigator: t, showHomeIcon: p, homeRoute: c, onToggleAppMenu: m } = d, [a, g] = N(!1), n = () => {
    const o = !a;
    g(o), m(o);
  }, s = !(r(i) && r(t));
  return /* @__PURE__ */ l(w.Fragment, { children: [
    /* @__PURE__ */ l(
      "div",
      {
        className: "navbar-header min-width-50 padding-5 overflow-hidden position-relative display-flex align-items-center",
        onClick: n,
        children: [
          /* @__PURE__ */ e("span", { className: `navbar-brand height-40 width-40 ${p ? "home-icon" : ""}`, children: !s && c }),
          s && /* @__PURE__ */ e("div", { className: "position-absolute right-2 bottom-0 text-color-white rotate-45", children: /* @__PURE__ */ e("span", { className: "rioglyph rioglyph-triangle-right" }) })
        ]
      }
    ),
    t && /* @__PURE__ */ e(h, { show: a, modalClassName: "padding-top-25", onClose: n, children: /* @__PURE__ */ e("div", { className: "width-100pct height-100pct", children: t }) }),
    i && /* @__PURE__ */ e(h, { show: a, modalClassName: "padding-15", onClose: n, children: i.map((o) => /* @__PURE__ */ e("li", { role: "presentation", children: o.route }, `link-icon-${o.key}`)) })
  ] });
};
export {
  C as default
};
//# sourceMappingURL=MobileAppMenu.js.map
